import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ExportHistoryFileParameter, getFile } from "@tecumseh/Services/downloadExportHistoryService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type ReportParameterParam = HasOnSuccess & ExportHistoryFileParameter & HasOnError;

type HandlerType = CustomApiHandler<ReportParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getFile(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const blob = new Blob([props.apiResult]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${props.parameter.fileName}`);
        link.download = `${props.parameter.fileName}`;
        link.click();

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const downloadExportHistoryFile = createHandlerChainRunner(chain, "DownloAdFile");
export default downloadExportHistoryFile;